/* ROUTER */
import { Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';

/* ASSETS */
import logo from './img/apc-logo.png';

/* STYLES */
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';

/* COMPONENTS */
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import OfficeInfo from './components/OfficeInfo/OfficeInfo';
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import Telemedicine from './components/OfficeInfo/Telemedicine';
import Insurances from './components/OfficeInfo/Insurances';
import OfficePolicy from './components/OfficeInfo/OfficePolicy';
import NewPatients from './components/OfficeInfo/NewPatients';
import PrivacyPolicy from './components/OfficeInfo/PrivacyPolicy';
import AccessibilityToolbar from './components/AccessibilityToolbar/AccessibilityToolbar';
import ChatBot from './components/ChatBot/ChatBot';
import Navigation from './components/Navigation/Navigation';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { conditionallyInitializeAnalytics } from './utils/analytics';
import { analytics } from './firebase';
// import AppointmentScheduler from './components/Appointment/AppointmentScheduler';

function App() {
  useEffect(() => {
    // Initialize Google Analytics with consent mode on app startup
    conditionallyInitializeAnalytics();
  }, []);

  return (
    <div className="App">
      <Navigation />
      <AccessibilityToolbar />
      <ChatBot />
      <div className="nav-section-w-logo" style={{display: 'none'}}>
        <Navbar id="nav" expand="lg">
          <Container>
            <Navbar.Brand href="/"><img src={logo} className="App-logo" alt="logo" /></Navbar.Brand>
            <Navbar.Toggle id="nav-toggle" aria-controls="navbarScroll" />
            <Navbar.Collapse id="basic-navbar-nav navbarScroll">
              <Nav id="nav-box" className="mr-auto my-2 my-md-0 navbar-expand-lg" style={{background: '#ffffff', width: '90%', fontSize: '12', fontStyle: 'bold' }} navbarScroll>
                <Nav.Link href="/" id="nav-link">Home</Nav.Link>
                <Nav.Link href="/About" id="nav-link">Our Team</Nav.Link>
                <NavDropdown title="Office Info" id="nav-link">
                  <NavDropdown.Item href="/OfficeInfo/Telemedicine" id="nav-link">Telemedicine</NavDropdown.Item>
                  <NavDropdown.Item href="/OfficeInfo/Insurances" id="nav-link">Insurances Accepted</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/OfficeInfo/OfficePolicy" id="nav-link">Office Policy</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/Contact" id="nav-link">Contact</Nav.Link>
                <div className="pt-portal">
                  <a className="pt-portal-link" href="https://www.questdiagnostics.com/" target="_blank" rel="noopener noreferrer">Patient Portal</a>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
       
      <main className="main-content">
        <Routes>
          <Route path='/' element={<Header/>} />
          <Route path='/About' element={<About/>} />
          <Route path='/OfficeInfo' element={<OfficeInfo/>} />
          <Route path='/Contact' element={<Contact/>} />
          <Route path='/OfficeInfo/Telemedicine' element={<Telemedicine/>} />
          <Route path='/OfficeInfo/Insurances' element={<Insurances/>} />
          <Route path='/OfficeInfo/OfficePolicy' element={<OfficePolicy/>} />
          <Route path='/OfficeInfo/NewPatients' element={<NewPatients/>} />
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>} />
          {/* Route for future appointment scheduling implementation */}
          {/* <Route path='/schedule' element={<AppointmentScheduler/>} /> */}
        </Routes>
      </main>
       
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;

